let $ = require('jquery');
let Backbone = require("backbone");
let POS = require("../POS.js");
let ReserveModalView = require("./ReserveModalView.js");

let main = function () {
    var ConsultModalView = Backbone.View.extend({
        el: "#consultModal",

        events: {
            'click .consultBlock': 'consultBlockClicked'
        },
        show: function(){
            mixpanel.track("打开线上咨询");
            this.$el.modal("show");
        },
        hide: function() {
            this.$el.modal("hide");
        },
        initialize: function (){
            this.reserveModalView = new ReserveModalView();
        },

        consultBlockClicked: function(e) {
            if ($(e.currentTarget).hasClass('chartOnline')){
                mixpanel.track("完成线上咨询");
            }

            if ($(e.currentTarget).hasClass('reserveConsult')){
                this.reserveModalView.show();
            }

            this.hide();
            return true;
        }
    });
    return ConsultModalView;
};

let exportedValue = main();
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/view/ConsultModalView.js